import { render, staticRenderFns } from "./FeatureCorrection.vue?vue&type=template&id=08b4e5b4&scoped=true"
import script from "./FeatureCorrection.vue?vue&type=script&lang=js"
export * from "./FeatureCorrection.vue?vue&type=script&lang=js"
import style0 from "./FeatureCorrection.vue?vue&type=style&index=0&id=08b4e5b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b4e5b4",
  null
  
)

export default component.exports